import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Cookie from 'js-cookie';
import en from '../../locales/en/common.json';
import th from '../../locales/th/common.json';

export const defaultLanguage = 'en';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    // translation: translationEN,
    translation: {
      ...en,
    },
  },
  th: {
    // translation: translationTH,
    translation: {
      ...th,
    },
  },
};

const clientLanguage = (
  Cookie.get('language')
  || (typeof localStorage !== 'undefined' && localStorage.getItem('language'))
  || defaultLanguage
);
export const getLanguage = (ctx) => (ctx && ctx.req
  ? ctx.req.i18n.language
  : clientLanguage
);
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: clientLanguage,

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    // ns: ['common'],
  });

export default i18n;
